import Component from "vue-class-component";
import Vue from "Vue";

@Component
export default class SkeletonSubmit extends Vue {
}



// WEBPACK FOOTER //
// ./src/shared/components/Skeleton/SkeletonSubmit/SkeletonSubmit.ts